import React from "react";
import { __t } from "@core/translation/translation";
import useStyles from "./styles";
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import ListItemText from "@material-ui/core/ListItemText";
import { Link } from "react-router-dom";

const SupportComponent = () => {
  const classes = useStyles();
  const [open, setOpen] = React.useState(true);

  const data = [
    { id: 0, name: __t("Send a ticket"), href: "/sendTicket" },
    { id: 1, name: __t("Tickets"), href: "/ticket" },
    { id: 2, name: __t("Contact Us"), href: "/contactUs" },
  ];
  const handleClick = () => {
    setOpen(false);
  };
  return (
    <div className={classes.root}>
      <List component="nav" aria-label="secondary mailbox folders">
        {data.map((item) => (
          <Link to={item.href} key={item.id} onClick={handleClick}>
            <ListItem className={classes.listItem}>
              <ListItemText primary={item.name} className={classes.text} />
              <i className="icon-chevron-left" />
            </ListItem>
          </Link>
        ))}
      </List>
    </div>
  );
};
export default SupportComponent;
